<template>
  <div>
    <h5 class="font-weight-bold">SMS Alert Service</h5>
    <form @submit.prevent="sendMessage">
      <div class="row mt-3">
        <div class="col">
          <div class="card rounded shadow-sm">
            <div class="card-body">
              <div class="form-group">
                <label for="">Template</label>
                <select
                  name=""
                  id=""
                  class="form-control"
                  v-model="selectedTemplate"
                  @change="getRecipients"
                  required
                >
                  <option value="" disabled selected hidden>Choose</option>
                  <option
                    v-for="template in templates"
                    :key="template.name"
                    :value="template.name"
                  >
                    {{ template.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="card rounded shadow-sm">
            <div class="card-body">
              <div class="form-group">
                <label for="">Send to</label>
                <Multiselect
                  v-model="recipients"
                  :options="options"
                  track-by="id"
                  :custom-label="nameWithCode"
                  placeholder="Choose"
                  :searchable="true"
                  :multiple="true"
                  :disabled="isDisabled"
                  required
                ></Multiselect>
              </div>

              <div class="form-group" v-show="!isDisabled">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    v-model="is_checked"
                    @change="is_checked ? selectAll() : unselectAll()"
                  />
                  <label class="form-check-label" for="gridCheck">
                    Select All
                  </label>
                </div>
              </div>

              <table v-show="recipients.length" class="table table-sm mt-3">
                <thead>
                  <th>ACCOUNT</th>
                  <th>NAME</th>
                  <th>MOBILE NO</th>
                  <th width="20%">AMOUNT</th>
                  <th width="25%">PERIOD</th>
                </thead>
                <tbody>
                  <tr v-for="recipient in recipients" :key="recipient.id">
                    <td>{{ recipient.account_type }}</td>
                    <td>{{ recipient.name }}</td>
                    <td>{{ recipient.mobile_no }}</td>
                    <td>
                      <input
                        type="text"
                        class="form-control"
                        v-model="recipient.amount"
                        :disabled="!isInputEnabled"
                        required
                      />
                    </td>
                    <td>
                      <div class="input-group">
                        <select
                          name=""
                          id=""
                          class="form-control"
                          v-model="recipient.semester"
                          :disabled="!isInputEnabled"
                          required
                        >
                          <option value="1st Sem">1st Sem</option>
                          <option value="2nd Sem">2nd Sem</option>
                        </select>
                        <select
                          name=""
                          id=""
                          class="form-control"
                          v-model="recipient.academic_year"
                          :disabled="!isInputEnabled"
                          required
                        >
                          <option value="2022-2023">2022-2023</option>
                          <option value="2021-2022">2021-2022</option>
                          <option value="2020-2021">2020-2021</option>
                        </select>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="card rounded shadow-sm">
            <div class="card-body">
              <div class="form-group">
                <label for="">Message</label>
                <textarea
                  name=""
                  id=""
                  cols="30"
                  rows="5"
                  class="form-control"
                  v-model="templateMessage"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="mb-3">
            <button
              id="send-message-btn"
              class="btn btn-primary"
              @click="sendMessage"
            >
              Send
            </button>
          </div>

          <div v-if="showLoader" class="mb-2">
            <p class="">
              Please wait. Do not refresh the page. Sending {{ counter }} out of
              {{ recipients.length }}.
            </p>
          </div>
        </div>
        <div class="col">
          <div class="card rounded shadow-sm">
            <div class="card-body">
              <div class="card-title">
                <strong>Add new contact</strong>
              </div>

              <div class="form-row">
                <div class="col">
                  <div class="form-group">
                    <label for="">Name</label>
                    <div class="input-group">
                      <input
                        v-model="contact.name"
                        type="text"
                        class="form-control"
                        placeholder=""
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label for="">Mobile Number</label>
                    <div class="input-group">
                      <input
                        v-model="contact.mobile_no"
                        type="input"
                        maxlength="11"
                        class="form-control"
                        placeholder="11-digit number"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group">
                    <label for="">Template</label>
                    <select
                      name=""
                      id=""
                      class="form-control"
                      v-model="contact.account_type"
                      required
                    >
                      <option value="" disabled selected hidden>Choose</option>
                      <option
                        v-for="template in templates"
                        :key="template.name"
                        :value="template.name"
                      >
                        {{ template.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <button
                id="add-new-contact-btn"
                @click.prevent="addNewContact"
                class="btn btn-primary"
              >
                Add
              </button>
            </div>
          </div>

          <div
            class="card rounded shadow-sm overflow-auto"
            style="height: 300px;"
          >
            <div class="card-body">
              <div class="card-title">
                <div class="form-inline">
                  <div class="form-group">
                    <label for="">From</label>
                    <input
                      type="date"
                      class="form-control mx-2"
                      v-model="from"
                    />
                  </div>

                  <div class="form-group">
                    <label for="">To</label>
                    <input type="date" class="form-control mx-2" v-model="to" />
                  </div>

                  <button
                    class="btn btn-primary mx-2"
                    @click.prevent="getSemaphoreMonthlyMessages"
                  >
                    Go
                  </button>
                </div>
              </div>
              <table
                id="recent-messages-table"
                class="table table-sm table-hover"
              >
                <tbody>
                  <tr
                    v-for="message in messages"
                    :key="message.id"
                    @click="openMessageModal(message)"
                  >
                    <td>{{ message.recipient_name }}</td>
                    <td>{{ message.recipient }}</td>
                    <td>{{ message.network }}</td>
                    <td>{{ message.status }}</td>
                    <td>{{ message.updated_at | dateTime }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="modal fade" id="message-modal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="message">
              {{ form.recipient_name }} - {{ form.recipient }} ({{
                form.network
              }})
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p style="white-space:pre-line">{{ form.message }}</p>
            <small class="text-muted"
              >Sent on: {{ form.updated_at | completeDateTime }}</small
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { templates } from './MessageTemplates';
import setMessage from './Message';

export default {
  name: 'Main',
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedTemplate: '',
      is_checked: false,
      templates: templates,
      recipients: [],
      showLoader: false,
      isDisabled: true,
      counter: 0,
      messages: [],
      templateMessage: '',
      from: '',
      to: '',
      options: [],
      contact: {
        name: '',
        mobile_no: '',
        account_type: '',
      },
      form: new Form({
        recipient_name: '',
        recipient: '',
        message: '',
        network: '',
        updated_at: '',
      }),
      enabledInputTemplates: [
        'CSP',
        'SIKAP',
        'TES',
        'TES_INDIVIDUAL',
        'TES_TDP',
      ],
    };
  },
  methods: {
    addNewContact() {
      if (
        Object.values(this.contact).some(
          (value) => value === null || value === ''
        )
      ) {
        toastr.error('All fields are required.', 'Error');
        return;
      }

      if (!/^\d{11}$/.test(this.contact.mobile_no)) {
        toastr.error('Invalid mobile number.', 'Error');
        return;
      }

      let btn = document.getElementById('add-new-contact-btn');
      btn.disabled = true;
      btn.innerHTML = 'Adding...';

      axios
        .post('api/sms/contact', this.contact)
        .then(() => {
          btn.disabled = false;
          btn.innerHTML = 'Add';
          toastr.success('Added successfully.', 'Information');
          this.getRecipients();
          this.contact.name = this.contact.mobile_no = this.contact.account_type =
            '';
        })
        .catch(() => {
          btn.disabled = false;
          btn.innerHTML = 'Add';
          toastr.error('Oops! Something went wrong.', 'Error');
        });
    },
    async sendMessage() {
      if (!this.recipients.length) {
        toastr.error('No recipient/s selected.', 'Error');
        return;
      }

      const btn = document.getElementById('send-message-btn');
      btn.innerHTML = 'SENDING';
      btn.disabled = true;
      this.showLoader = true;

      for (const recipient of this.recipients) {
        this.counter++;
        await this.toSempahore(recipient);
      }

      this.recipients = [];
      toastr.success(
        `Successfully sent (${this.counter}) message/s.`,
        'Information'
      );
      this.is_checked = false;
      this.counter = 0;
      btn.innerHTML = 'SEND';
      btn.disabled = false;
      this.showLoader = false;
    },

    hasEmptyFields(array) {
      return array.every((obj) => {
        return obj.amount == '' || obj.semester == '' || obj.academic_year == ''
          ? true
          : false;
      });
    },
    toSempahore(recipient) {
      return axios
        .post('api/sms', {
          message: setMessage(this.selectedTemplate, recipient, this.templateMessage),
          number: recipient.mobile_no,
        })
        .then((res) => {})
        .catch((err) => {
          toastr.error(
            'Unable to send message.',
            'Oops! Something went wrong.'
          );
        });
    },
    getRecipients() {
      this.recipients = [];
      this.is_checked = false;

      axios
        .get('api/sms/recipients', {
          params: {
            account_type: this.selectedTemplate,
          },
        })
        .then((res) => {
          this.options = res.data.map((obj) => ({
            ...obj,
            amount: '',
            semester: '',
            academic_year: '',
          }));
          this.isDisabled = false;
          this.getTemplateMessage();
        })
        .catch((err) => {
          toastr.error(
            'Unable to get recipients.',
            'Oops! Something went wrong.'
          );
        });
    },
    getSemaphoreMonthlyMessages() {
      axios
        .get('api/recent-sms', {
          params: {
            from: this.from,
            to: this.to,
          },
        })
        .then((res) => {
          this.messages = res.data.reverse();
        })
        .catch((err) => {});
    },
    openMessageModal(data) {
      $('#message-modal').modal('show');
      this.form.fill(data);
    },
    nameWithCode({ name }) {
      return name;
    },
    selectAll() {
      this.recipients = [];
      this.options.forEach((option) => {
        this.recipients.push(option);
      });
    },

    unselectAll() {
      this.recipients = [];
    },
    getTemplateMessage() {
      this.templates.find((template) => {
        if (template.name == this.selectedTemplate) {
          this.templateMessage = template.message;
          return;
        }
      });
    },
  },

  computed: {
    isInputEnabled() {
      return this.enabledInputTemplates.includes(this.selectedTemplate);
    },
  },

  mounted() {},
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
#recent-messages-table tr {
  cursor: pointer !important;
}
</style>
